import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiResponse } from '@app/service/api-response';
import { UtilService } from '@app/service/util.service';

import { HMemberService } from '@home/service/member.service';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-paid-member-bank',
  templateUrl: './paid-member-bank.component.html',
  styleUrls: ['./paid-member-bank.component.scss']
})
export class PaidMemberBankComponent implements OnInit {

  errorResponse: ApiResponse;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    private utilService: UtilService,
    private toastrService: ToastrService,
    private router: Router,
    private memberService: HMemberService,
    public activeModal: NgbActiveModal
  ) {

  }

  ngOnInit(): void {
  }

  /*******************************************************************************
    설  명 : 무통장 입금 신청
  *******************************************************************************/
  public setPaymentBank() {
    if ( confirm('무통장 입금으로 신청하시겠습니까?') ) {
      this.memberService.setPaymentBank().then(response => {
        if ( response.ResultCode === true ) {
          this.toastrService.success(response.ResultMessage, '유료회원 결제');

          this.activeModal.close(true);
        } else {
          this.toastrService.error(response.ResultMessage, '유료회원 결제');
        }
      });
    }
  }

}
